import { render, staticRenderFns } from "./New Online Course Page UK.vue?vue&type=template&id=aec7537c&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec7537c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIHeader: require('/opt/build/repo/components/UI/Header.vue').default,UIFooter: require('/opt/build/repo/components/UI/Footer.vue').default})
